/* 布局 */
//前台
import Layout from "@views/layout";

const ebookpassageRouter = {
    path: "/business",
    component: Layout,
    redirect: {
        name: "BUSINESS"
    },
    children: [
            {
            path: "ebookpassage",
            name: "EBOOKPASSAGE",
            meta: {
                title: "电子期刊关键章节信息管理",
                sort: 1,
            },
            component: () => import("@views/business/ebookpassage/index.vue"),
            redirect: {
                name: "EBOOKPASSAGE_LIST",
            },
            children: [
                {
                    path: "list",
                    name: "EBOOKPASSAGE_LIST",
                    meta: {
                        title: "电子期刊关键章节信息管理",
                        sort: 2,
                        keepAlive:true
                    },
                    component: () => import("@views/business/ebookpassage/list.vue"),
                },
                                {
                    path: "add",
                    name: "EBOOKPASSAGE_ADD",
                    meta: {
                        title: "新增电子期刊关键章节信息管理",
                        parentPath: '/business/ebookpassage/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebookpassage/form.vue"),
                },
                                                {
                    path: "edit",
                    name: "EBOOKPASSAGE_EDIT",
                    meta: {
                        title: "编辑电子期刊关键章节信息管理",
                        parentPath: '/business/ebookpassage/list',
                        operate: true,
                    },
                    component: () => import("@views/business/ebookpassage/form.vue"),
                },
                                        ],
    },


        ],
};

export default ebookpassageRouter;
